import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { RootState } from "../store"

export const teamApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_APP_API_URL}/${import.meta.env.VITE_APP_API_VERSION}`,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState
      const authToken = state.auth.masquerade_access_token || state.auth.api_access_token
      const tokenType = state.auth.token_type
      headers.set("Content-Type", "application/json")
      headers.set("Accept", "application/json")
      if (authToken) {
        headers.set("authorization", `${tokenType} ${authToken}`)
      }
      return headers
    },
  }),

  reducerPath: "teamApi",
  endpoints: (builder) => ({
    getTeamMembers: builder.mutation<any, any>({
      query: (payload) => ({
        url: "/users/team_members",
        method: "POST",
        body: payload,
      }),
    }),
    getTeamPerformance: builder.mutation<any, any>({
      query: (payload) => ({
        url: `/metrics/summary/team`,
        method: "POST",
        body: payload,
      }),
    }),
  }),
})

export const { useGetTeamPerformanceMutation, useGetTeamMembersMutation } = teamApi
